import { render } from "./addDialog.vue?vue&type=template&id=c85e7830&scoped=true"
import script from "./addDialog.vue?vue&type=script&lang=js"
export * from "./addDialog.vue?vue&type=script&lang=js"

import "./addDialog.vue?vue&type=style&index=0&id=c85e7830&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c85e7830"]])

export default __exports__